const messages = {
  titleColorRev: "true",
  buttons: {
    pending: "Venter",
    open: "Åpne",
    requestAccess: "Be om tilgang",
  },
  myBsApps: '<span class="text-danger">Mine applikasjoner</span> Bridgestone',
  my: "Mine applikasjoner",
  directRoute: "Dine direkte lenker til Bridgestone webapplikasjoner.",
  welcomeMessage:
    'Velkommen til BRIDGESTONE PLUS <span class="text-danger">PLUS</span>, %{first_name} %{last_name}',
  showProfile: "Vis profil",
  newMessages: "Ny melding i innboksen",
  myApps: "Mine applikasjoner",
  allApps: "Alle applikasjoner",
  myAppsDescription: "Alle Bridgestone webapplikasjoner du er registrert for.",
  allAppsDescription:
    "Alle Bridgestone webapplikasjoner som kan være relevante for deg.",
  myProfile: {
    welcomeMessage:
      "Velkommen til ditt personlige område. Her kan du oppdatere eller justere opplysningene dine og se innboksen din.",
    masterData: "Stamdata",
    completeDetails:
      "Fullfør dine personlige og selskapsdata for sikre korrekt registrering.",
    goToMasterData: "Gå til mine data",
    goToInbox: "Gå til innboks",
  },
  masterData: {
    welcomeMessage:
      "Velkommen til ditt personlige område. Her kan du oppdatere eller justere stamdataene dine.",
    personalDetails: "Personopplysninger",
    companyDetails: "Selskapsdata",
    emailAddress: "E-postadresse",
    title: "Tittel",
    surname: "Etternavn",
    firstName: "Fornavn",
    jobPosition: "Stilling",
    streetAndHouseNumber: "Selskapsadresse",
    postalCode: "Postnummer",
    city: "Sted",
    country: "Land",
    legalStructure: "Rettsform",
    customerNumber: "Bridgestone kundenummer",
    importantPleaseRead: "Viktig, vennligst les",
    customerNumberInfo:
      "For å tilordne dekkbestillingene dine til ulike forhandlere riktig, er det viktig å oppgi kundenummeret ditt.",
    multipleCustomerNumbers:
      "Hvis du har flere kundenumre hos en forhandler, f.eks. for hovedvirksomheten og underavdelinger, vennligst oppgi hovedvirksomhetens kundenummer først.",
    salesAssignment:
      "Salg knyttet til andre kundenumre tilordnes hovedvirksomheten din.",
    supplier: "Leverandør",
    addAnotherCustomerNumber: "Legg til kundenummer",
    save: "Lagre",
    delete: "Slett",
  },
  inbox: {
    welcomeMessage: "Her finner du varsler og viktige nyheter.",
    sender: "Avsender",
    subject: "Emne",
    date: "Dato",
    formConsulting: "Skjema mottatt – Takk for at du fullførte profilen din.",
    back: "Tilbake",
  },
  legalAndContact: {
    cookieSettings: "Informasjonskapselinnstillinger",
    dataPolicy: "Datareglement",
    termsOfUse: "Bruksvilkår",
    helpAndContact: "Hjelp og kontakt",
  },
  logInSignUp: {
    logIn: "Logg inn",
    signUp: "Registrer deg",
    logInMessage: "Logg inn med e-postadressen og passordet ditt.",
    signUpMessage: "Hvis du er ny bruker, vennligst registrer deg.",
  },
};

export default {
  messages,
};
